import { FDHeadlineText } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';

const HeadlineText = ({
  align, size, value, ...rest
}) => {
  return (<FDHeadlineText
    {...useDataAttrs(rest)}
    align={align}
    size={size}
    value={value}
  />);
};

HeadlineText.defaultProps = {
  align: inputDefaultProps.align,
};

HeadlineText.propTypes = {
  align: inputPropTypes.align,
  size: inputPropTypes.size.isRequired,
  value: inputPropTypes.value.isRequired,
};

export { HeadlineText };
